<template>
  <v-container>
    <h5 class="text-h5">Stock Operation</h5>
    <v-divider></v-divider>
    <loading v-if="loading"></loading>
    <v-row>
      <v-col v-for="stock in stocks" :key="stock.id" cols="12">
        <v-card>
          <stock-preview :stock="stock"></stock-preview>

          <v-card-actions>
            <v-btn small @click="show(stock)">
              <v-icon>search</v-icon> Ver
            </v-btn>
            <v-btn small @click="regularize(stock)">
              <v-icon>auto_fix_high</v-icon> Regularizar
            </v-btn>
            <v-btn small @click="add(stock)">
              <v-icon>add</v-icon> Reposición
            </v-btn>
            <v-btn small @click="move(stock)">
              <v-icon>sync_alt</v-icon> Envío
            </v-btn>
            <v-btn small @click="remove(stock)">
              <v-icon>delete</v-icon> Baja
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-col>
    </v-row>

    <simple-dialog v-model="dialog" @close="onDialogClose" :title="getDialogTitle">
      <v-card v-if="stockSelected" flat>

        <stock-view v-if="stockSelected && operation === 'SHOW'"
                    :stock="stockSelected"

        ></stock-view>

        <stock-add v-if="stockSelected && operation === 'ADD'"
                   :stock="stockSelected"
                   @stockAdded="onStockChange"
        ></stock-add>

        <stock-move v-if="stockSelected && operation === 'MOVE'"
                    :stock="stockSelected"
                    @stockMoved="onStockChange"
        ></stock-move>

        <stock-remove v-if="stockSelected && operation === 'REMOVE'"
                      :stock="stockSelected"
                      @stockRemoved="onStockChange"
        ></stock-remove>

        <stock-regularize v-if="stockSelected && operation === 'REGULARIZE'"
                      :stock="stockSelected"
                      @stockRegularize="onStockChange"
        ></stock-regularize>

      </v-card>
    </simple-dialog>
  </v-container>
</template>

<script>
import StockProvider from "@/modules/delivery/providers/StockProvider";
import {Loading, SimpleDialog} from "@dracul/common-frontend"
import StockAdd from "@/modules/delivery/pages/stock/StockOperationPage/StockAdd";
import StockMove from "@/modules/delivery/pages/stock/StockOperationPage/StockMove";
import StockView from "@/modules/delivery/pages/stock/StockOperationPage/StockView";
import StockRemove from "@/modules/delivery/pages/stock/StockOperationPage/StockRemove";
import StockRegularize from "@/modules/delivery/pages/stock/StockOperationPage/StockRegularize";
import StockPreview from "@/modules/delivery/components/StockPreview";
import StockOperationProvider from "@/modules/delivery/providers/StockOperationProvider";

export default {
  name: "StockOperationPage",
  components: {StockPreview, StockRemove, StockView, StockMove, StockAdd, StockRegularize, Loading, SimpleDialog},
  data() {
    return {
      dialog: false,
      loading: false,
      stockSelected: null,
      operation: null,
      stocks: []
    }
  },
  created() {
    this.populateStocks()
        .finally(() => this.fetchStock())
  },
  computed: {
    getDialogTitle() {
      if (this.stockSelected && this.operation) {
        return this.stockSelected.branch.name + " - " + this.$t('delivery.stockOperation.' + this.operation)
      } else {
        return ""
      }
    }
  },
  methods: {
    populateStocks() {
      return new Promise((resolve) => {
        this.loading = true
        StockOperationProvider.populateStocks()
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
    fetchStock() {
      this.loading = true
      StockProvider.fetchStock()
          .then(r => {
            this.stocks = r.data.fetchStock
          }).finally(() => this.loading = false)
    },
    onDialogClose() {
      this.dialog = false
      this.operation = null
      this.stockSelected = null
    },
    show(stock) {
      this.operation = 'SHOW'
      this.stockSelected = stock
      this.dialog = true
    },
    add(stock) {
      this.operation = 'ADD'
      this.stockSelected = stock
      this.dialog = true
    },
    move(stock) {
      this.operation = 'MOVE'
      this.stockSelected = stock
      this.dialog = true
    },

    remove(stock) {
      this.operation = 'REMOVE'
      this.stockSelected = stock
      this.dialog = true
    },
    regularize(stock) {
      this.operation = 'REGULARIZE'
      this.stockSelected = stock
      this.dialog = true
    },
    onStockChange() {
      this.fetchStock()
    },

  }
}
</script>

<style scoped>

</style>
